
angular.module('bmsApp.directives')
		.directive('pageTitle', function () {
			return {
				restrict: 'E',
				transclude: true,
				scope: {
					title: '=',
					module: '@'
				},
				replace: true,
				template: '<div class="row page-title-container">' +
								'<div class="col-xs-10">' +
									'<h2 class="page-title"><ng-transclude></ng-transclude></h2>' +
								'</div>' +
								'<div class="col-xs-2 text-right"><img class="loading-image" ng-src="images/module-icons/{{ module }}.png"></div>' +
								'<div style="clear:both;">' +
									'<div style="margin:0 15px 0 15px;border-bottom:1px solid #ccc;padding-top:5px;"></div>' +
								'</div>' +
						'</div>',
			};
		});

